<template lang="pug">
  div
    v-col(md="12").contentOutPadding.tablaGR
      v-data-table#tableComments(
        :headers="headers"
        :items="comments"
        :page.sync="page"
        :items-per-page="itemsPerPageCustom"
        hide-default-footer
        class="elevation-1"
        item-key="idGenerate"
        :loading="loading"
        :loading-text="loadingtext"
        @page-count="computedPages = $event"
      )
        template(v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }")
          span(v-if="header.value === 'user_name'")
            span {{ header.text }}

            .boxOrder(v-if="isDelivery")
              <sort :orderBy="'site_normalized_rating_global'" :orderByActual="ordering" @sort="setOrder($event)" />
            .boxOrder(v-else)
              <sort :orderBy="'rating_global'" :orderByActual="ordering" @sort="setOrder($event)" />
          span(v-else-if="header.value === 'source_date'")
            span {{ header.text }}
            .boxOrder
              <sort :orderBy="'source_date'" :orderByActual="ordering" @sort="setOrder($event)" />
          span(v-else) {{ header.text }}

        template(v-slot:item.user_name="{ item }")
          v-tooltip(right color="#222226" open-on-click=true max-width="450" nudge-bottom="40" nudge-right="10" content-class="tooltip-help tooltip-help-rigth")
            template(v-slot:activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on" class='cursor-pointer d-flex items-center justify-center pb-2' @click="handleClickHighlight(item)")
                svg(:id="`start-icon-${item.id}`" width="20" height="20" viewBox="0 0 24 24" :fill="item.is_featured ? '#F41A39':'none'" stroke="#F41A39" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class='hover-resize' )
                  path(d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14 2 9.27l6.91-1.01L12 2z")
            span(v-if="item?.is_featured") #[translate Remover opinion como destacada]
            span(v-else) #[translate Destacar opinión]

          div.boxNoteAndName(v-if="isDelivery")
            div.d-flex.justify-center.items-center(v-if="item['site_info']['code'] === 'JUS'")
              div.d-flex.justify-center.items-center
                div.d-flex.justify-center.items-center(v-if="!item['site_rating']")
                  span -
                div.d-flex.justify-center.items-center(v-else)
                  just-eat-rating(:ranking="+(item['site_rating'].toFixed(2))")

            div.d-flex.justify-center.items-center(v-if="item['site_info']['code'] === 'GLV'")
              div.d-flex.justify-center.items-center
                div.d-flex.justify-center.items-center(v-if="!item['site_rating']")
                  span -
                div.d-flex.justify-center.items-center.gap-0_5em(v-else)
                  GlovoRating(:percent="(item['site_rating'] > 5 ? 5 : item['site_rating']) / 5 * 100" :custom-bad="true")

            div.d-flex.justify-center.items-center(v-if="item['site_info']['code'] === 'UBE'")
              div.d-flex.justify-center.items-center
                div.d-flex.justify-center.items-center(v-if="!item['site_rating']")
                  span -
                div.d-flex.justify-center.items-center.gap-0_5em(v-else)
                  img(:src="img.imgStar")
                  span {{ item['site_rating'] | formatNumber }}
            .boxName.font-weight-med.text-center(dark :title="item.user_name") {{ item.user_name }}
          div.boxNoteAndName.d-flex.flex-col.justify-center.items-center(v-else)
            div.d-flex.gap-0_25em
              span.boxDown(v-if="showDownComment(item)")
                img.down(:src="imgCommons.down" width="14" height="14" :class="{'rotate':item.comentariocompleto}" @click="showComments(item)")
              span.boxNote(dark)
                span(:style="{backgroundColor: getColorByNoteNormalized({note: getNoteNormalized(item.rating_global), type: 'color'})}" v-if="item.rating_global != null") {{ getNoteNormalized(item.rating_global) }}
                span.withOutNote(v-else) -
            .boxName.font-weight-med.text-center(dark :title="item.user_name") {{ item.user_name }}

        template(v-slot:item.text="{ item, index }")
          div.d-flex.justify-end
            div.removedCategory.mt-1(v-if="item.deleted_in_site") {{ $gettext('Removed by Google') }}
          div#block-comment(:data-review-id="item.id")
            tags-external-review(
              v-if="item.site_info.code === 'GOO'" 
              :tags="googleTags(item)" 
              :site="item.site" 
              :siteInfo="item.site_info"
            )
            tags-external-review(:tags="item.tags" :site="item.site" :siteInfo="item.site_info")
            p.px-4.border-20(v-if="item.link_to_publication_img" )
              v-img(:src="item.link_to_publication_img" max-width="150" @mousedown="picture = item.link_to_publication_img; showImage = true;" v-on:error="item.link_to_publication_img = null")
                template(v-slot:default)
                  v-row(class="fill-height ma-0" align="center" justify="center")
                    v-icon(color="white") mdi-eye

            p.comentario(id="parraf" :class="{'nocomment': !item.text}" dark)
              div.font-weight-bold.text-black {{ item.title }}
              span(v-html="getTextOpinion(item)")
              div.comentario.translation(v-if="item.review_translation")
                strong {{ $gettext('Translation') }}
                p(v-html="item.review_translation.text")
            div.d-flex.gap-2.mb-1(v-if="item.photos?.length && item.site_info.code === 'GOO'")
              v-img(:src="item.photos[0].url" max-width="130" max-height="130")
              v-img(v-if="item.photos.length >= 2" :src="item.photos[1].url" max-width="130" max-height="130")

              v-carousel(v-if="item.photos.length > 2" hide-delimiters height="130")
                v-carousel-item(
                  v-for="(photo,i) in filterPhotos(item.photos)"
                  :key="i"
                  :src="photo.url"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                )
            div(v-if="isDelivery")
              tags-internal-review(:tags="item.categories" :isDelivery="true" :hasEditTags="hasEditTags" :indexComment="index" :idComment="item.id"
                @addTagOk="addNewTagComment"
                @removeTag="removeTagInternal" @linkFilterByCategory="linkFilterByCategory" :complaintProducts="item['complaint_products']")
            div(v-else)
              tags-internal-review(:tags="item.categories"  :isDelivery="false" :hasEditTags="hasEditTags" :indexComment="index" :idComment="item.id"
                @addTagOk="addNewTagComment"
                @removeTag="removeTagInternal" @linkFilterByCategory="linkFilterByCategory")
            div.respuesta(v-show="item.showReply")
              errors(v-if="deleteReplyError.show && deleteReplyError.itemId === item.id" :errors="deleteReplyError.message")
              div(v-if="item.site_info.code === 'TRI'")
                div(v-if="item.error")
                  div.d-flex.pt-2
                    div.d-flex.align-center {{ item.messageError }}
                    div.d-flex.flex-column.justify-end.align-start.px-4
                      v-btn.py-2.my-1(data-site="TripAdvisor" data-listener="false" color='primary' tile min-width="100" max-height="30" @click='item.error = undefined')
                        | #[translate Retry]

                div(v-else-if="item.allow_reply && userCanReply")
                  div(v-if="item.reply && item.reply.text && item.reply.text.length")
                    div.px-2.font-weight-bold {{ item.reply.creator_email || 'Response' }}
                    div.d-flex.pt-2
                      div.flex-fill.px-4.py-2.rounded.bg-EBEBEB {{ item.reply.text }}
                      div.d-flex.flex-column.justify-end.align-start.px-4
                  div(v-else)
                    answers-chat-gpt(:hasPremium="canLoadAnswersChatGPT" @setAnswer="saveReplyChatGPT" :item="item")
                    div.d-flex.align-center.px-2.font-weight-bold.column-gap-0_5em(@mousedown="openDefaultAwnsers = true; currentItem = item;")
                      v-icon.cursor-pointer(color="terciary") mdi-square-edit-outline
                      span.cursor-pointer
                        | #[translate Pick up a default answer]
                    div.d-flex.pt-2
                      textarea.flex-fill.px-4.py-2.rounded.bg-white.border-B7C4CB(v-model="item.unsavedReply" @mousedown="currentItem = item" @input="autoSize")
                      div.d-flex.flex-column.justify-end.align-start.px-4
                        v-btn.py-2.my-1.btn-awnser-tp(data-site="TripAdvisor" data-listener="false" color='primary' tile min-width="100" max-height="30" :loading="item.saving" :disabled="!item.unsavedReply || item.saving" @click='currentItem = item')
                          | #[translate Answer]
                div(v-else)
                  div(v-if="item.reply")
                    div.px-2.font-weight-bold {{ item.reply.creator_email || 'Response' }}
                    div.d-flex.pt-2
                      div.flex-fill.px-4.py-2.rounded.bg-EBEBEB {{ item.reply.text }}
                      div.d-flex.flex-column.justify-end.align-start.px-4(v-if="item.allow_delete_reply")
                        div.pa-1.rounded.bg-EBEBEB(
                          @click='deleteReply(item)' 
                          :class="{'cursor-pointer': !deletingReplyStatus && item.allow_delete_reply}"
                        )
                          v-icon(color="terciary" :disabled="deletingReplyStatus || !item.allow_delete_reply") mdi-delete-outline
              div(v-else-if="(item.site_info.status.linked !== 'Connected' || item.site_info.status.status !== 'Active') && item.site_info.name.toLowerCase() ==='google'")
                div.d-flex.justify-center.align-center
                  v-btn.py-2.my-1(v-if="item.site_info.status.status === 'Not open'" color="red" tile min-width="100" max-height="30")
                    | Local cerrado
                  v-btn.py-2.my-1(v-if="item.site_info.name === 'Google' && item.site_info.status.status !== 'Not open'" :loading="settinUpGoogle" color='primary' tile min-width="100" max-height="30" @mousedown="googleSetup(item)")
                    | #[translate Google Setup]
                  v-btn.py-2.my-1(v-if="['Facebook','Instagram'].includes(item.site_info.name) && item.site_info.status.status !== 'Not open'" :loading="settinUpFacebook"  color='primary' tile min-width="100" max-height="30" @mousedown="facebookSetup(item)")
                    | #[translate Facebook Setup]
              div(v-else-if="(item.allow_reply && userCanReply) || (item.allow_reply && enableAnswers(item))")
                div(v-if="item.reply && item.reply.text && item.reply.text.length")
                  div.px-2.font-weight-bold {{ item.reply.creator_email || 'Response' }}
                  div.d-flex.pt-2
                    div.flex-fill.px-4.py-2.rounded.bg-EBEBEB {{ item.reply.text }}
                    div.d-flex.flex-column.justify-end.align-start.px-4(v-if="item.site_info.code !== 'FBK'")
                      div.pa-1.rounded.bg-EBEBEB(
                        @click='deleteReply(item)' 
                        :class="{'cursor-pointer': !deletingReplyStatus && item.allow_delete_reply}"
                      )
                        v-icon(color="terciary" :disabled="deletingReplyStatus || !item.allow_delete_reply") mdi-delete-outline
                div(v-else)
                  answers-chat-gpt(v-if="['google','cover manager','glovo', 'thefork'].includes(item.site_info?.name?.toLowerCase()) && item.showReply" :hasPremium="canLoadAnswersChatGPT" @setAnswer="saveReplyChatGPT" :item="item" :is-delivery="isDelivery")
                  div.d-flex.align-center.px-2.font-weight-bold.column-gap-0_5em(@mousedown="openDefaultAwnsers = true; currentItem = item;")
                    v-icon.cursor-pointer(color="terciary") mdi-square-edit-outline
                    span.cursor-pointer
                      | #[translate Pick up a default answer]
                  div.d-flex.pt-2
                    div.d-flex.flex-column.flex-fill
                      small.text-red(v-if="item.site_info.code === 'GLV'") {{$gettext("You're about to respond to a review. Please note that, due to GLOVO's policies, published responses cannot be deleted or edited once submitted.")}}
                      textarea.flex-fill.px-4.py-2.rounded.bg-white.border-B7C4CB(v-model="item.unsavedReply" @mousedown="currentItem = item" @input="autoSize")
                    div.d-flex.flex-column.justify-end.align-start.px-4
                      v-btn.py-2.my-1(color='primary' tile min-width="100" max-height="30" :loading="savingReplyStatus" :disabled="!item.unsavedReply || savingReplyStatus" @click='saveReply(item)')
                        | #[translate Answer]
              div(v-else)
                div(v-if="item.reply")
                  div.px-2.font-weight-bold {{ item.reply.creator_email || 'Response' }}
                  div.d-flex.pt-2
                    div.flex-fill.px-4.py-2.rounded.bg-EBEBEB {{ item.reply.text }}
                    div.d-flex.flex-column.justify-end.align-start.px-4(v-if="item.allow_delete_reply && item.site_info.code !== 'FBK'")
                      div.pa-1.rounded.bg-EBEBEB(
                        @click='deleteReply(item)' 
                        :class="{'cursor-pointer': !deletingReplyStatus && item.allow_delete_reply}"
                      )
                        v-icon(color="terciary" :disabled="deletingReplyStatus || !item.allow_delete_reply") mdi-delete-outline
          div#block-comment(v-if="item.showReply && item.historic_reviews")
            div(v-for="history in item.historic_reviews" class="d-flex pa-2" style="border-top: 2px solid #E5E6E7; background-color: #fafafa")
              div.boxNoteAndName
                span.boxNote(dark)
                  span(:style="{backgroundColor: getColorByNoteNormalized({note: getNoteNormalized(history.site_rating * 2), type: 'color'})}" v-if="history.site_rating") {{ getNoteNormalized(history.site_rating * 2) }}
              div.ml-4.flex-1
                strong {{ history.source_date | moment("DD/MM/YYYY") }}
                p.comentario.mt-2 {{ history.text }}
                div(v-if="history?.historicreviewresponse?.creator_email && history?.historicreviewresponse?.text")
                  span {{ $gettext('respondido por') }}
                  strong {{ history?.historicreviewresponse?.creator_email }}
                  span el {{ history?.historicreviewresponse?.source_date | moment("DD/MM/YYYY") }}
                  p {{ history?.historicreviewresponse?.text }}
        template(v-slot:item.center="{ item }")
          router-link.btnCentro.link-text(v-if="typeNode !== 'center'" :to="goItemNextLevelCustom(item)") {{ item.center.name }}
          span.btnCentro(v-else) {{ item.center.name }}
        template(v-slot:item.source_date="{ item }")
          span.text-date {{ item.source_date | moment("DD/MM/YYYY") }}
        template(v-slot:item.site_logo="{ item }")
          div.text-center
            div(v-if="item.url")
              a.cursor-pointer(target="_blank" :href="item.url")
                img(:src="item.site_logo")
            div(v-else)
              img(:src="item.site_logo")
        template(v-slot:item.reply="{ item }")
          v-tooltip(v-if="item.error_in_reply" color="#222226" open-on-click=true content-class="tooltip-help tooltip-help-rigth" top)
            template(v-slot:activator="{ on, attrs }")
              div.text-center(v-bind="attrs" v-on="on")
                v-icon(color="error" size="24") mdi-alert-circle-outline
            span #[translate Error al responder]
          v-tooltip(v-else color="#222226" open-on-click=true content-class="tooltip-help tooltip-help-rigth" top :disabled="item.site_info.code === 'TRI'")
            template(v-slot:activator="{ on, attrs }")
              div.text-center(v-bind="attrs" v-on="on")
                a(target="_blank" :href="item.url" v-if="item.site_info && item.site_info.code === 'TRI' && item.reply === null" )
                  img.cursor-pointer(:src="img.openTri" width="24")
                img.cursor-pointer(v-else-if="item.site_info && item.site_info.code === 'TRI' && item.reply !== null" :src="img.replyYes" width="24" @click="showReply(item)")
                img.cursor-pointer(v-else="(item.reply || enableAnswers(item)) && item.site_info.code !== 'TRI'" :src="imgToReply(item)" width="24" @click="showReply(item)")
            span(v-if="item.reply == null && item.site_info.code !== 'TRI'") {{ $gettext('Reply') }}
            span(v-else-if="item.site_info.code === 'TRI'" )
            span(v-else="item.reply") {{ $gettext('See answer') }}

    //PAGINACION
    v-row#itemsPagePagination(v-if="computedPages > 1")
      v-col.text-left(md="8")
      v-col.text-right(md="4")
        v-pagination.paginationFooter(v-if="pagination && comments"
          v-model="page"
          :length="computedPages"
          @input="handlePageChange"
        )
    facebook-locations(v-if="facebookConfig.app_id && center" @update="updateItem" :selected.sync="facebookSelected" :center.sync="center" :current-facebook-linkeded="currentFacebookLinkeded" :app-id="facebookConfig.app_id" :api-version="facebookConfig.api_version" :open.sync="openFacebookLocations")
    google-link(:open.sync="openGoogleLink" @update="updateItem")
    awnsers(v-if="currentCenterId" :open.sync="openDefaultAwnsers" @onSelect="addDefaultAwnser" :center-id="currentCenterId.toString()")

    v-dialog(v-model="showImage" max-width="650")
      v-card
      v-toolbar.ligthbox-header(dense color="elevation-0")
        v-spacer
        v-btn(icon color="black" @click.native="showImage = false")
        v-icon(color="white") mdi-close
      v-row(no-gutters)
        v-col(cols="12")
        v-row(no-gutters align="center" justify="center")
          v-img(:src="picture" contain)
</template>

<script>
import commonMixins from "@/mixins/common.js";
import SrvGlobal from "@/services/local";
import SrvFeedback from "@/services/feedback.js";
import FacebookLocations from "@/components/local/FacebookLocations";
import GoogleLink from "@/components/local/GoogleLink";
import Awnsers from "@/components/common/Awnsers";
import GlovoRating from "@/components/common/GlovoRating.vue";
import tagsExternalReview from "@/components/common/tagsExternalReview.vue";
import tagsInternalReview from "@/components/common/tagsInternalReview.vue";
import AnswersChatGpt from "@/components/feedback/AnswersChatGPT.vue";
import Sort from "@/components/common/Sort.vue"
import JustEatRating from "@/components/common/justEatRating.vue";
import Errors from "@/components/common/Errors.vue";

export default {
  mixins: [commonMixins],
  components: {GlovoRating, Awnsers, GoogleLink, FacebookLocations, tagsExternalReview, tagsInternalReview, AnswersChatGpt, Sort, JustEatRating, Errors}, // USAMOS COMPONENTE PARA LOS FILTROS DE TIPO COMBOBOX
  props: {
    employedId: {
      type: Number,
      default: null,
      required: false,
    },
    comments: {
      type: Array,
      default: null,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
      required: true,
    },
    pagination: {
      type: Boolean,
      default: false,
      required: false,
    },
    isDelivery: {
      type: Boolean,
      default: false,
      required: false,
    },
    notResponse: {
      type: Boolean,
      default: false,
    },
    totalPages: {
      type: Number,
      default: 0,
      required: false
    },
  },
  data() {
    return {
      items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
      showImage: false,
      showAddCategories: false,
      picture: "",
      page: 1, // PAGINA EN LA QUE ESTAMOS
      pageCount: 0, // PAGINAS TOTALES
      itemsPerPage: 10, // ELEMENTOS POR PAGINA
      img: {
        imgStar: require("@/assets/img/star.svg"),
        sort: require("@/assets/img/mini_arrow_shack_disable.svg"),
        sortActive: require("@/assets/img/mini_arrow_shack_active.svg"),
        replyNo: require("@/assets/img/ico-reply-no.svg"),
        replyYes: require("@/assets/img/ico-reply-yes.svg"),
        replyNoHistoric: require("@/assets/img/ico-reply-no-historic.svg"),
        replyYesHistoric: require("@/assets/img/ico-reply-yes-historic.svg"),
        changedReplyYesHistoric: require("@/assets/img/ico-changed-reply-yes-historic.svg"),
        openTri: require("@/assets/img/open-tri.svg"),
      },
      ordering: "-source_date",
      options: {}, // OPCIONES DE V-TABLE
      loadingtext: this.$gettext("Loading comments"),
      totalWidth: 0,
      nextScrollUrl: null,
      nextCall: false,
      opinionCounts: "",
      facebookConfig: {
        app_id: undefined,
        api_version: undefined,
      },
      currentItem: undefined,
      center: undefined,
      openFacebookLocations: false,
      facebookSelected: undefined,
      currentFacebookLinkeded: [],
      savingReplyStatus: false,
      deletingReplyStatus: false,
      currentFacebookToLink: undefined,
      openGoogleLink: false,
      settinUpGoogle: false,
      settinUpFacebook: false,
      openDefaultAwnsers: false,
      mocking: false,
      computedPages: 0,
      deleteReplyError: {
        show: false,
        message: "",
        itemId: null,
      },
    };
  },
  mounted() {
    window.openTripAdvisor = this.openTripAdvisor;
    window.closeTripAdvisor = this.closeTripAdvisor;
    window.savingTripAdvisor = this.savingTripAdvisor;
    window.commitTripAdvisor = this.commitTripAdvisor;
    window.showErrorTripAdvisor = this.showErrorTripAdvisor;
  },
  watch: {
    totalPages() {
      if (this.pagination && typeof this.totalPages === "number") {
        this.computedPages = Math.ceil(this.totalPages / this.itemsPerPageCustom);
      }
    },
    totalWidth: function () {
      return this.totalWidth;
    },
    page(currentValue, lastValue) {
      if (this.pagination) {
        currentValue > lastValue ? this.handleNext() : this.handlePrevious()
      }
    },
  },
  computed: {
    currentCenterId() {
      if (this.currentItem) return this.currentItem.center.id
      return null
    },
    headers() {
      let heads = [
        // CABECERAS DE LA TABLE COMENTARIOS
        {text: this.$gettext("DATE"), value: "source_date", sortable: false, width: "7%"},
        {
          text: this.$gettext("NOTE"),
          align: "start",
          sortable: false,
          value: "user_name",
          width: "9%",
        },
        {text: this.$gettext("SITE"), value: "site_logo", sortable: false, width: "4%"},
        {text: "CENTRO", value: "center", sortable: false, width: "9%"},

        {text: this.$gettext("COMMENT"), value: "text", sortable: false, width: "55%"},
        {text: this.$gettext("RESP."), value: "reply", sortable: false, width: "6%"},
      ];
      if (this.notResponse || this.isDelivery) {
        heads = heads.filter((e) => e.value != "reply");
      }

      return heads;
    },
    hasEditTags() {
      return true;
    },
    itemsPerPageCustom() {
      return this.comments.length;
    },
    userCanReply() {
      if (this.mocking) {
        return true;
      } else {
        return JSON.parse(window.localStorage.getItem("_user_info")).can_reply_reviews;
      }
    },
    canLoadAnswersChatGPT() {
      return JSON.parse(window.localStorage.getItem("_user_info")).can_use_chatgpt_to_answer;
    },
    opinionsCategoriesSelected() {
      return this.$store.getters.getOpinionsCategoriesSelected.map((c) => c.value);
    },
  },
  methods: {
    translateApiErrorMessage(message, fallback) {
      if (!message) return fallback;
      const map = {
        "Review does not exist": this.$gettext("Review does not exist"),
      };
      return map[message] || message;
    },
    googleTags(item) {
      const tags = []
      if(item.site_ratings?.cuisine) {
        tags.push({
          tag: {name: this.$gettext('Kitchen')},
          rating: item.site_ratings?.cuisine
        })
      }
      if(item.site_ratings?.service) {
        tags.push({
          tag: {name: this.$gettext('Service')},
          rating: item.site_ratings?.service
        })
      }
      if(item.site_ratings?.ambient) {
        tags.push({
          tag: {name: this.$gettext('Environment')},
          rating: item.site_ratings?.ambient
        })
      }
      return tags
    },
    filterPhotos(photos) {
      return photos.filter((_, index) => index > 2);
    },
    validateDateReview(item) {
      if (!item.source_date) return false

      const date = this.$moment(item.source_date);
      const last30days = this.$moment().subtract(30, 'days');

      return date.isAfter(last30days);
    },
    enableAnswers(item) {
      console.log('enableAnswers', item)
      if (item.site_info.code === 'GLV' && item?.hid && this.validateDateReview(item)) {
        return this.userCanReply
      }
      return item.allow_reply && this.userCanReply
    },
    handleClickHighlight(item) {
      if (item) {
        const starNode = document.getElementById(`start-icon-${item.id}`);
        starNode.style.fill = !item.is_featured ? "#F41A39" : "transparent";

        this.comments = this.comments.map((innerItem) => {
          if (innerItem.id === item.id) return {...innerItem, is_featured: !innerItem.is_featured}
          return innerItem
        })

        SrvFeedback.toggleFeaturedOpinion({reviewId: item.id, reviewType: this.isDelivery ? 'delivery' : 'internet', isFeatured: !item.is_featured}).then(() => {
        }).catch(() => {
          starNode.style.fill = item.is_featured ? "#F41A39" : "transparent";
        })
      }
    },
    imgToReply(item) {
      let img = null;
      const hasHistorical = item?.historic_reviews?.length > 0;
      const wasChanged = item?.historic_reviews?.length ? item.historic_reviews[0].site_rating !== item.site_rating : false
      if (item.reply !== null) {
        img = hasHistorical ? wasChanged ? this.img.changedReplyYesHistoric : this.img.replyYesHistoric : this.img.replyYes;
      } else {
        img = hasHistorical ? this.img.replyNoHistoric : this.img.replyNo;
      }
      return img;
    },
    async removeTagInternal(data) {
      this.comments[data.indexComment].categories = this.comments[data.indexComment].categories.filter((c) => c.id != data.category.id);
      const res = await SrvFeedback.removeOrAddCategorie({review_id: this.comments[data.indexComment].id, category_id: data.category.id, action: "delete", review_type: !this.isDelivery ? "internet" : "delivery"});
      if (res.status === 200) {
        this.comments[data.indexComment].categories = this.comments[data.indexComment].categories.filter((c) => c.id != data.category.id);
      }
    },
    addNewTagComment(data) {
      this.comments[data.indexComment].categories.push(data.category);
    },
    async addTagInternal() {
    },

    // SE ACTUALIZA EL NÚMERO DE PAGINA
    handlePageChange(value) {
      this.page = value;
    },
    handleNext() {
      this.$emit("handlePageChange", "next");
    },
    handlePrevious() {
      this.$emit("handlePageChange", "previous");
    },
    showErrorTripAdvisor(id, message = null) {
      this.$set(window.data[id], "error", true);
      this.$set(window.data[id], "messageError", message ? message : "¡Ha ocurrido un error!");
    },
    async commitTripAdvisor(id) {
      await this.sleep(1000);
      if (!window.data[id].reply) {
        this.$set(window.data[id], "reply", {});
      }
      this.$set(window.data[id].reply, "text", window.data[id].unsavedReply);
      this.$set(window.data[id], "unsavedReply", undefined);
    },
    savingTripAdvisor(id, status) {
      this.$set(window.data[id], "saving", status);
    },
    openTripAdvisor() {
      this.comments.forEach((item) => {
        if (item.site_info.code === "TRI" && item.allow_reply && this.userCanReply) {
          item.showByPlugin = true;
        }
      });
    },
    closeTripAdvisor() {
      this.comments.forEach((item) => {
        if (item.site_info.code === "TRI") {
          item.showReply = false;
        }
      });
    },
    addDefaultAwnser(awnser) {
      this.currentItem.unsavedReply = awnser;
    },
    updateItem() {
      // Frist mockup
      // this.$set(this.currentFacebookToLink.site_info.status, "linked", "Connected")
      // this.$set(this.currentFacebookToLink.site_info.status, "status", "Active")

      // Reload All
      location.reload();
    },
    autoSize(inputEvent) {
      inputEvent.target.style.height = "";
      inputEvent.target.style.height = inputEvent.target.scrollHeight + 2 + "px";
    },
    saveReplyChatGPT(info) {
      this.currentItem = info.item;
      this.currentItem.unsavedReply = info.text;
    },
    async saveReply(item) {
      this.currentItem = item || this.currentItem;
      this.savingReplyStatus = true;
      this.deleteReplyError.show = false;
      this.deleteReplyError.itemId = null;
      if (this.$config.featureConfig.socialReply) {
        this.$emit("changeLoadingStatus", true);
        const {status, data} = this.isDelivery ? await SrvGlobal.setReply(this.currentItem.unsavedReply, this.currentItem.id, true) :  
        await SrvGlobal.setReply(this.currentItem.unsavedReply, this.currentItem.id);
        if (status === 200 && data?.success) {
          this.$set(this.currentItem, "reply", data.reply);
          this.$set(this.currentItem, "unsavedReply", undefined);
          this.$emit("getOpinions");
          this.$emit("changeLoadingStatus", false);
        } else {
          const fallback = this.$gettext("An error occurred while saving the reply.");
          this.deleteReplyError.message = this.translateApiErrorMessage(data?.error?.message, fallback) || fallback;
          this.deleteReplyError.show = true;
          this.deleteReplyError.itemId = this.currentItem?.id ?? null;
          this.$emit("changeLoadingStatus", false);
        }
      } else {
        await this.sleep(3000);
        if (!this.currentItem.reply) {
          this.currentItem.reply = {};
        }
        window.reply = this.currentItem.unsavedReply;
        this.$set(this.currentItem.reply, "text", this.currentItem.unsavedReply);
        this.$set(this.currentItem, "unsavedReply", undefined);
      }
      this.savingReplyStatus = false;
    },
    async deleteReply(item) {
      if(!item.allow_delete_reply || this.deletingReplyStatus) return;
      this.deletingReplyStatus = true;
      if (this.$config.featureConfig.socialReply) {
        this.$emit("changeLoadingStatus", true);
        const {status, data} = await SrvGlobal.deleteReply(this.currentItem.reply.id);
        if (status === 200 && data.success) {
          this.$set(this.currentItem, "reply", null);
          this.$set(this.currentItem, "unsavedReply", undefined);
          this.$emit('changeLoadingStatus', false);
        } else if (!data.success) {
          const fallback = this.$gettext("An error occurred while deleting the reply.");
          this.deleteReplyError.message = this.translateApiErrorMessage(data?.error?.message, fallback) || fallback;
          this.deleteReplyError.show = true;
          this.deleteReplyError.itemId = this.currentItem?.id ?? null;
          this.$emit('changeLoadingStatus', false);
        }
      } else {
        await this.sleep(3000);
        this.$set(this.currentItem, "allow_reply", true);
        this.$set(this.currentItem, "showReply", false);
        this.$set(this.currentItem, "reply", null);
        this.$set(this.currentItem, "unsavedReply", undefined);
      }
      this.deletingReplyStatus = false;
    },
    async googleSetup(item) {
      this.settinUpGoogle = true;
      this.center = item.center.id;
      this.currentGooleToLink = item;

      this.$nextTick(() => {
        this.openGoogleLink = true;
        this.settinUpGoogle = false;
      });
    },
    async facebookSetup(item) {
      this.settinUpFacebook = true;
      !this.facebookConfig && (await this.getLocalMarketing());
      !this.currentFacebookLinkeded && (await this.getCurrentFacebookLinkeded());
      this.facebookSelected = item.site_info.status.page_id;
      this.center = item.center.id;
      this.currentFacebookToLink = item;

      this.$nextTick(() => {
        this.openFacebookLocations = true;
        this.settinUpFacebook = false;
      });
    },
    async getLocalMarketing() {
      const {status, data} = await SrvGlobal.getLocalMarketing();
      if (status === 200) {
        this.facebookConfig = data.facebook_config;
      }
    },
    async getCurrentFacebookLinkeded() {
      const {status, data} = await SrvGlobal.getCurrentFacebookLinkeded();
      if (status === 200) {
        this.currentFacebookLinkeded = data.face_centers;
      }
    },
    downloadExcelCustom() {
      let params = {ordering: this.ordering};
      this.downloadExcel(params, this.opinionCounts);
    },
    goItemNextLevelCustom(item) {
      let itemCustom = {};
      itemCustom.id = item.center.id;
      itemCustom.name = item.center.name;
      itemCustom.level = 9;
      itemCustom.returnUrl = true;
      return this.goItemNextLevel(itemCustom, true);
    },
    showReply(item) {
      this.deleteReplyError.show = false;
      item.showReply = !item.showReply;
      this.currentItem = item;
    },
    getTextOpinion(item) {
      let text = "";
      if (item.text !== null && item.text !== "") {
        text += item.text.replace("\n", "<br>");
        text = text.replace("Positivo", "<b>Positivo</b>");
        text = text.replace("Negativo", "<b>Negativo</b>");
      }
      if (item.text === null && item.tags && item.tags.length === 0) {
        text = this.$gettext("The user has not written a review.");
      }
      return text;
    },
    setOrder(val) {
      this.ordering = val;
      this.page = 1;
      this.$emit("setOrder", this.ordering);
    },
    showDownComment: function (item) {
      if (item.text && item.text.length > 80) {
        return true;
      }
      return true;
    },
    showComments: function (item) {
      item.comentariocompleto = item.comentariocompleto !== true;
      if ((item.reply || (item.allow_reply && this.userCanReply))) {
        item.showReply = false;
      } else {
        item.showReply = !item.showReply;
      }
    },
    linkFilterByCategory(category) {
      this.$emit("linkFilterCategory", category);
    },
  },
};
</script>

<style lang="scss" scoped>
.removedCategory {
  background-color: #d61a23;
  font-size: 0.55rem;
  margin-top: -4px;
  color: #fff;
  border-radius: 15px;
  padding: 2px 10px;
  text-align: center;
}
.translation {
  border-top: 1px solid #000;
  padding-top: 5px;

  p {
    background-color: #ebebeb;
  }
}

.ligthbox-header {
  position: absolute;
  width: 100%;
  z-index: 999;
  background: transparent !important;
}

.border-20 .v-image {
  border-radius: 5%;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.contentOutPadding {
  .v-carousel {
    height: 150px;
    width: 150px;
  }
}
.respuesta {
  padding: 1em;
  border-top: solid #e5e6e7 2px;
}

.categoriesCoverManager {
  padding-left: 1em;

  .boxIcon {
    background-color: #eaeaea;
    border-radius: 15px;
    padding: 4px 10px;
    font-size: 0.75rem;
    color: #666;
    margin-right: 7px;
    margin-bottom: 15px;
    display: inline-block;
    max-width: 90px;

    svg,
    span {
      vertical-align: middle;
    }

    span {
      color: #ffffff;
    }
  }
}

.bgRed {
  background-color: #d61a23;
}

.bgOrange {
  background-color: #fcae19;
}

.bgGreen {
  background-color: #89c445;
}

.boxOrder {
  float: right;
}

.boxNoteAndName {
  .boxDown {
    width: 10%;
    text-align: center;

    .down {
      margin-top: 5px;
      display: inline-block;
      transition: all ease 0.3s;
      cursor: pointer;

      &.rotate {
        transform: rotate(90deg);
      }
    }
  }

  .boxNote {
    width: 79%;
    margin-left: 10%;

    span {
      color: #fff;
      border-radius: 5px;
      width: 38px;
      padding: 4px 0;
      display: inline-block;
      text-align: center;

      &.withOutNote {
        background-color: #eaeaea;
        color: #000;
      }
    }
  }

  .boxDown,
  .boxNote {
    display: inline-block;
    vertical-align: middle;
  }

  .boxName {
    color: #52575a;
    margin: 5px 0 0 0;
    font-size: 0.625rem;
    line-height: 0.625rem;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100px;
  }
}

.comentario {
  transition: all ease 0.3s;
  font-size: 0.813rem;
  margin-top: -4px;

  &.comentarioRecortado {
    height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: fit-content;
    min-width: 0;
  }
}

.tipo {
  width: 15px;
  height: 15px;
  display: block;
  border-radius: 3px;
  margin: 0 auto;
}

.filters {
  padding: 15px 0;
}

.block-count {
  font-size: 1.125rem;
}

.block-head {
  border-bottom: 1px solid #dfe3e6;
}
</style>
